export const tableLoadingStyles = {
  tableContainer: theme => ({
    borderRadius: '12px',
    boxShadow: theme.shadows[4],
    width: '100%',
    overflow: 'hidden',
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      width: '100%',
      tableLayout: 'fixed',
    },
  }),

  tableHead: theme => ({
    '& .MuiTableCell-root': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: 600,
      fontSize: '1rem',
      borderBottom: 'none',
      '&:first-of-type': {
        borderTopLeftRadius: '12px',
      },
      '&:last-of-type': {
        borderTopRightRadius: '12px',
      },
    },
  }),

  tableRow: theme => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
    // Subtle loading animation
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  }),

  tableCell: theme => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),

  headerSkeleton: {
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    '&::after': {
      background:
        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
    },
  },

  cellSkeleton: {
    '&::after': {
      background: theme =>
        theme.palette.mode === 'dark'
          ? 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)'
          : 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent)',
    },
  },

  actionsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1,
  },

  actionButtonSkeleton: {
    '&::after': {
      background: theme =>
        theme.palette.mode === 'dark'
          ? 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)'
          : 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent)',
    },
  },
};
